import { render, staticRenderFns } from "./GithubAuth.vue?vue&type=template&id=7bd30ad6&scoped=true&"
import script from "./GithubAuth.vue?vue&type=script&lang=js&"
export * from "./GithubAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd30ad6",
  null
  
)

export default component.exports